import { Modal, Input } from 'antd';
import Approvers from '../../../modules/common/Approvers';
import { IDocument } from '.';
interface Props {
  visible: boolean;
  handleOk: any;
  handleCancel: any;
  data?: IDocument;
}
function EdoSearchRemarkModal({
  visible,
  handleOk,
  handleCancel,
  data,
}: Props) {
  const { TextArea } = Input;
  return (
    <>
      <Modal
        data-testid="edo-search-modal"
        title={data?.class.full_name + '. ' + data?.document_id}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width="1000px"
      >
        <p>Примечание</p>
        <TextArea value={data?.remark} />
      </Modal>
    </>
  );
}

export default EdoSearchRemarkModal;
